import { Injectable } from '@angular/core';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  { name: 'stripe', src: 'https://js.stripe.com/v3/' },
];

declare var document: any;

@Injectable()
export class DynamicScriptLoaderService {
  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve) => {
      if (!this.scripts[name].loaded) {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (name == 'maps-googleapis') {
          script.setAttribute('defer', '');
          script.setAttribute('async', '');
        }
        if (script.readyState) {
          //IE
          script.onreadystatechange = () => {
            if (
              script.readyState === 'loaded' ||
              script.readyState === 'complete'
            ) {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          //Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) =>
          resolve({
            script: name,
            loaded: false,
            status: 'Loaded',
            message: error.message,
          });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }

  loadScriptByUrl(url, scriptId, callBack) {
    return new Promise((resolve) => {
      if (
        !document.getElementById(scriptId) ||
        !localStorage.getItem('localizeKeys')
      ) {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = scriptId;

        if (script.readyState) {
          //IE
          script.onreadystatechange = () => {
            if (
              script.readyState === 'loaded' ||
              script.readyState === 'complete'
            ) {
              script.onreadystatechange = null;
              if (callBack) callBack();
              resolve('');
            }
          };
        } else {
          //Others
          script.onload = () => {
            if (callBack) callBack();
            resolve('');
          };
        }
        script.onerror = (error: any) => {
          if (callBack) callBack();
          resolve('');
        };

        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        if (callBack) callBack();
        resolve('');
      }
    });
  }
}
